import styled from 'styled-components';

const Asterisk = styled.span`
   color: ${({ theme }) => theme.primaryRed};
   padding: 0 2px;
   ::after {
      content: '*';
   }
`;

export default Asterisk;
